import DefaultButton from "../../../components/buttons/default.button";
import { useState } from "react";
import FormTextInput from "../../../components/inputs/texts/form.text.input";
import { ReactComponent as PlusIcon } from "../../../assets/icons/add.icon.svg";
import SimpleFormAndTable from "../../../components/simpleFormAndTable/simpleFormAndTable";
const FORM_FIELDS = {
  name: "",
  rsId: "",
};

const ASSET_TYPES = [
  {
    name: "Chromebook",
    rsId: 232522,
  },
  {
    name: "Desktop",
    rsId: 49825,
  },
  {
    name: "Game Console",
    rsId: 65729,
  },
  {
    name: "iPad",
    rsId: 232524,
  },
  {
    name: "Laptop",
    rsId: 191779,
  },
  {
    name: "MacBook",
    rsId: 232523,
  },
  {
    name: "Phone",
    rsId: 50441,
  },
  {
    name: "Smart Watch",
    rsId: 293894,
  },
  {
    name: "Tablet",
    rsId: 50442,
  },
];

const ASSET_TYPE_FIELDS = [
  {
    type: "text",
    label: "Name",
    name: "name",
  },
  {
    type: "number",
    label: "RS ID",
    name: "rsId",
    min: 0,
  },
];

const Page = () => {
  const [formFields, setFormFields] = useState(FORM_FIELDS);
  const [assetTypes, setAssetTypes] = useState(ASSET_TYPES);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormFields({ ...formFields, [name]: value });
  };
  return (
    <div
      style={{ height: "calc(100vh - 72px)" }}
      className="p-4 flex flex-col gap-2 overflow-y-hidden"
    >
      <h1 className="font-ubuntuBold text-lg items-center text-center">
        Asset Admin
      </h1>
      <SimpleFormAndTable
        formProps={{
          fields: ASSET_TYPE_FIELDS,
          handleChange,
          formFields,
        }}
        tableProps={{ data: assetTypes }}
      />
    </div>
  );
};

export default Page;
